module.exports = __webpack_public_path__ + "static/media/cyber-security-sky-blue.780b4d07.gif";